import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Cwosignup from './Cwosignup'; // Adjust the path as necessary

const stripePromise = loadStripe(process.env.REACT_APP_SUPERADMIN_STRIPE_PUBLIC_KEY || "");

const CwosignupWrapper = (props: any) => (
  <Elements stripe={stripePromise}>
    <Cwosignup {...props} />
  </Elements>
);

export default CwosignupWrapper;
